import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface SaveFocusInboxEnableActionMessage {
    isFocusedInboxEnabled: boolean | null;
    mailboxInfo: MailboxInfo;
}
export const saveFocusInboxEnable: (
    isFocusedInboxEnabled: boolean | null,
    mailboxInfo: MailboxInfo
) => SaveFocusInboxEnableActionMessage = action(
    'saveFocusInboxEnable',
    (
        isFocusedInboxEnabled: boolean | null,
        mailboxInfo: MailboxInfo
    ): SaveFocusInboxEnableActionMessage => ({
        isFocusedInboxEnabled,
        mailboxInfo,
    })
);
